import React, { useState } from 'react';
import { Button } from 'react-bootstrap5';

import useW9FormLink from 'components/Common/Billing/Hooks/useW9FormLink';

import ChooseCreatePaymentMethod from './ChooseCreatePaymentMethod';

export default function NoPaymentMethods() {
  const { loading: loadingW9FormLink, w9FormLink } = useW9FormLink();
  const [show, setShow] = useState(false);

  const downloadW9Form = () => {
    if (w9FormLink) {
      window.open(w9FormLink, '_blank', 'noreferrer');
    }
  };

  return (
    <div className="h-100 d-flex flex-column justify-content-center border rounded-5 p-5 text-center">
      <p>
        You do not have any payment method
      </p>

      <Button
        className="d-block mx-auto"
        onClick={() => setShow(true)}
      >
        Add Payment Method
      </Button>

      <div className="mt-2 small fw-light text-muted">
        Some description
      </div>

      <Button
        variant="outline-primary"
        className="btn-reverse d-block mt-4 mx-auto"
        disabled={loadingW9FormLink}
        onClick={downloadW9Form}
      >
        Download W-9 Form
      </Button>
      <ChooseCreatePaymentMethod
        show={show}
        onHide={() => setShow(false)}
      />
    </div>
  );
}
